import { render } from "./PricingComponent.vue?vue&type=template&id=0c870d53"
import script from "./PricingComponent.vue?vue&type=script&lang=js"
export * from "./PricingComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__